module.exports = __webpack_public_path__ + "static/media/YB5F01_1.1f696ebd.jpg";